module.exports = __webpack_public_path__ + "img/Leaderboard-unchecked.219105cf.svg";